import axios from 'axios'

// Create axios instance
const api = axios.create({
  baseURL: `/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add any auth headers here if needed
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    console.error('API Error:', error)

    // Preserve the original error structure so we can check status codes and response data
    // in component error handlers
    if (error.response) {
      // Server responded with error status - preserve the original error
      return Promise.reject(error)
    } else if (error.request) {
      // Request was made but no response received
      const networkError = new Error('Network error - please check your connection')
      networkError.isNetworkError = true
      return Promise.reject(networkError)
    } else {
      // Something else happened
      const requestError = new Error('Request failed')
      requestError.isRequestError = true
      return Promise.reject(requestError)
    }
  }
)

// Songs API - only endpoints that still exist on backend
export const songsAPI = {
  // Search YouTube (backend proxies YouTube API)
  searchYouTube: (query, limit = 5) =>
    api.get('/songs/search/youtube', { params: { q: query, limit } }),

  // Submit YouTube URL for processing
  submitYouTubeUrl: (url, addedBy = 'anonymous', roomCode = null) =>
    api.post('/songs/submit', {
      url,
      added_by: addedBy,
      room_code: roomCode
    }),

  // Retry processing job
  retryProcessingJob: (jobId) => api.post(`/songs/jobs/${jobId}/retry`),

  // Get processing job status (used by PracticePage polling)
  getProcessingJob: (jobId) => api.get(`/songs/jobs/${jobId}`),

  // Wake the processing worker after a job was durably queued in Convex
  wakeProcessingJob: (jobId) => api.post(`/songs/jobs/${jobId}/wake`),
}

// Health check
export const healthAPI = {
  check: () => api.get('/health'),
}

export default api
